/**
 * NextLayerStudio - QR Landingpage Section
 * Scoped per Section-Instanz, damit mehrere Sections auf derselben Seite
 * sich nicht gegenseitig stoeren (Shopify Theme Editor erlaubt Mehrfachnutzung).
 */
(function () {
  "use strict";

  var prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  function initReveal(root) {
    var items = root.querySelectorAll("[data-reveal]");
    if (!items.length) return;

    if (prefersReducedMotion || !("IntersectionObserver" in window)) {
      items.forEach(function (el) {
        el.classList.add("is-visible");
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -40px 0px" }
    );

    items.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initFaq(root) {
    var faqRoot = root.querySelector("[data-faq]");
    if (!faqRoot) return;

    faqRoot.addEventListener("click", function (event) {
      var button = event.target.closest(".nls-faq__question");
      if (!button || !faqRoot.contains(button)) return;

      var item = button.closest(".nls-faq__item");
      var panel = document.getElementById(button.getAttribute("aria-controls"));
      var isOpen = item.classList.contains("is-open");

      item.classList.toggle("is-open", !isOpen);
      button.setAttribute("aria-expanded", String(!isOpen));
      if (panel) panel.setAttribute("aria-hidden", String(isOpen));
    });
  }

  function initSection(section) {
    initReveal(section);
    initFaq(section);
  }

  function init() {
    document.querySelectorAll(".nls-landing").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Shopify Theme Editor: Section-Neuladen bei Bearbeitung im Live-Preview abfangen.
  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.querySelector(".nls-landing");
    if (section) initSection(section);
  });
})();
